import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'youtube-third-party-glyph-icon'

export function YoutubeSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path
        fill="current"
        fillRule="evenodd"
        d="m19.337 15.932-4.591 2.431-.002-3.743v-1.138l2.07 1.105 2.523 1.345Zm5.492-3.296s-.165-1.199-.674-1.726c-.647-.69-1.372-.695-1.703-.735C20.072 10 16.504 10 16.504 10h-.008s-3.57 0-5.947.176c-.332.039-1.056.043-1.704.735-.508.527-.674 1.725-.674 1.725S8 14.041 8 15.448v1.317c0 1.407.17 2.813.17 2.813s.167 1.197.675 1.724c.648.692 1.498.67 1.875.742 1.36.133 5.78.175 5.78.175s3.572-.007 5.952-.181c.331-.041 1.056-.044 1.703-.737.509-.527.674-1.724.674-1.724S25 18.172 25 16.765v-1.317c0-1.407-.17-2.813-.17-2.813Z"
        clipRule="evenodd"
      />
    </symbol>
  )
}

const YoutubeStandaloneContent = standalone(YoutubeSymbol, ID)

export const Youtube = styled(function YoutubeStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-youtube">
      <YoutubeStandaloneContent />
    </Icon>
  )
})``

export const YoutubeLightweight = styled(function YoutubeComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-youtube">
      {lightweight(ID)}
    </Icon>
  )
})``
